class TikTokContent extends HTMLElement {

    constructor() {

        super();  

        this.html_container = this.querySelector('.tiktok-container');
        this.data_wrapper = this.querySelector('.tiktok-data');
        this.pre_items = this.data_wrapper.querySelectorAll('.tiktok-item');
 
        if(this.pre_items.length != 0) { 
            this.item_cnt = Number(this.data_wrapper.querySelector('.tiktok-item:last-child').dataset.cnt);
            this.loadHandler() 
        } else {
            console.log('No TikTok items found')
            this.remove();
        }

    }


    loadHandler() {
        this.pre_items.forEach(i => {

            const i_id = BigInt(i.dataset.id);
            const i_username = i.dataset.user;
            const i_title = i.dataset.name;
            //console.log(i_title);

            if(i_username != '' && i_id != '') {
                (async () => { 
                    let data = await this.fetchData(i_id, i_username) 
                    if(data != null) { 
                        this.create_dummy_HTML_item(data, i_title);
                        this.classList.remove('none')
                    }
                })();  
            } else {
                console.log('missing id')
            }
    
        })
    }


    async fetchData(id, username) { 
        try {
            const response = await fetch(`https://www.tiktok.com/oembed?url=https://www.tiktok.com/@${username}/video/${id}`);
            const jsonData = await response.json();
            return jsonData;
        } catch (error) {       
            console.log('There was an error', error);
            return null;
        }         
    }


    create_dummy_HTML_item(data, title) {

        // Create main container
        const item = document.createElement('li');
               
        // Create thumb placeholder
        const aspect_box = document.createElement('div')
        aspect_box.classList.add('image-holder'); 
        item.append(aspect_box)

        // Create thumb
        const thumb = document.createElement('img');
        thumb.src = data.thumbnail_url;
        data.title == '' ? thumb.alt = `${title}` : thumb.alt = `${data.title}`
        thumb.setAttribute('loading', 'lazy');
        thumb.setAttribute('width', data.thumbnail_width);
        thumb.setAttribute('height', data.thumbnail_height);
        thumb.classList.add('cover-image');
        aspect_box.append(thumb)
        
        // // Create pseudo-play button
        const pseudobtn = document.createElement('button');
        pseudobtn.setAttribute('type', 'button');
        pseudobtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" fill="none" viewBox="0 0 10 14"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.48177 0.814643C0.81532 0.448245 0 0.930414 0 1.69094V12.2081C0 12.991 0.858787 13.4702 1.52503 13.0592L10.5398 7.49813C11.1918 7.09588 11.1679 6.13985 10.4965 5.77075L1.48177 0.814643Z" fill="currentColor"/></svg>`
        pseudobtn.classList.add('pseudobutton');
        aspect_box.append(pseudobtn)

        // // Create TikTok icon (top left)
        const tiktok_icon = document.createElement('div')
        tiktok_icon.classList.add('tiktok-icon');
        tiktok_icon.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" width="16" height="18" fill="none" xmlns="http://www.w3.org/2000/svg"><path style="position: relative; transform: scale(1.6);" d="M8.02 0H11s-.17 3.82 4.13 4.1v2.95s-2.3.14-4.13-1.26l.03 6.1a5.52 5.52 0 11-5.51-5.52h.77V9.4a2.5 2.5 0 101.76 2.4L8.02 0z" fill="currentColor"></svg>'
        aspect_box.append(tiktok_icon)

        // // Create loader icon
        const loader_icon = document.createElement('div')
        loader_icon.classList.add('tiktok-loader');
        loader_icon.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" class="absolute vh-center">
                <defs>
                    <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                        <stop stop-color="#fff" stop-opacity="0" offset="0%"/>
                        <stop stop-color="#fff" stop-opacity=".631" offset="63.146%"/>
                        <stop stop-color="#fff" offset="100%"/>
                    </linearGradient>
                </defs>
                <g fill="none" fill-rule="evenodd">
                    <g transform="translate(1 1)">
                            <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"/></path>
                            <circle fill="#fff" cx="36" cy="18" r="1"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"/></circle>
                    </g>
                </g>
            </svg>`;
        aspect_box.append(loader_icon)   

        pseudobtn.addEventListener('click', () => {
            this.handlePseudoBtnClick(data.html, item, aspect_box, pseudobtn, loader_icon, thumb)
        })
        
        this.html_container.append(item)

    }


    handlePseudoBtnClick(html, item, aspectbox, pseudobtn, loader, thumb) {

        pseudobtn.remove();       
        thumb.style.opacity = '0.5';
        loader.style.opacity = '1';

        const parser = new DOMParser();
        let embed_markup = parser.parseFromString(html, "text/html").querySelector('body > blockquote');  
        embed_markup.querySelector('section').innerHTML = '';     
        item.append(embed_markup)

        this.attachMutationObserver(embed_markup, aspectbox);   
        
        setTimeout(() => {
            const script = document.createElement('script')
            script.type = 'text/javascript';
            script.src = 'https://www.tiktok.com/embed.js';
            item.append(script)
        }, 200) 
   
    }


    attachMutationObserver(embed_markup, aspectbox) {

        let options = { childList: true };                    
        let callback = (mutationList, observer) => {
            for (const mutation of mutationList) {
                if(mutation.addedNodes.length != 0) {                        
                    aspectbox.remove();
                }
            }
        };

        let mutationObserver = new MutationObserver(callback);
        mutationObserver.observe(embed_markup, options);  

    }


}
customElements.define('tiktok-content', TikTokContent)